/* unplugin-vue-components disabled */import { render } from "./answer.vue?vue&type=template&id=7996a281&scoped=true"
import script from "./answer.vue?vue&type=script&lang=js"
export * from "./answer.vue?vue&type=script&lang=js"

import "./answer.vue?vue&type=style&index=0&id=7996a281&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7996a281"],['__file',"src/components/ai-chat-v2/ai-assistant/answer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7996a281"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7996a281', __exports__)) {
    api.reload('7996a281', __exports__)
  }
  
  module.hot.accept("./answer.vue?vue&type=template&id=7996a281&scoped=true", () => {
    api.rerender('7996a281', render)
  })

}


export default __exports__